import { render, staticRenderFns } from "./Peta.vue?vue&type=template&id=c7fde1fa&scoped=true"
import script from "./Peta.vue?vue&type=script&lang=js"
export * from "./Peta.vue?vue&type=script&lang=js"
import style0 from "./Peta.vue?vue&type=style&index=0&id=c7fde1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fde1fa",
  null
  
)

export default component.exports